import { Directive, HostListener, ElementRef } from '@angular/core';

@Directive({
  selector: '[toUpperCase]',
})
export class ToUpperCaseDirective {
  lastValue!: string;

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event']) onInput(event: {
    key: string;
    ctrlKey: boolean;
    metaKey: boolean;
    target: {
      selectionStart: any;
      selectionEnd: any;
      value: string;
      dispatchEvent: (arg0: Event) => void;
    };
    preventDefault: () => void;
  }) {
    if (
      // Allow: Delete, Backspace, Tab, Escape, Enter, etc
      event.key === 'ArrowUp' || // Allow: Ctrl+A
      event.key === 'ArrowDown' || // Allow: Ctrl+A
      event.key === 'ArrowLeft' || // Allow: Ctrl+A
      event.key === 'ArrowRight' || // Allow: Ctrl+A
      event.key === 'Backspace' || // Allow: Ctrl+A
      event.key === 'Delete' || // Allow: Ctrl+A
      event.key === 'Tab' || // Allow: Ctrl+A
      (event.key === 'a' && event.ctrlKey === true) || // Allow: Ctrl+A
      (event.key === 'c' && event.ctrlKey === true) || // Allow: Ctrl+C
      (event.key === 'v' && event.ctrlKey === true) || // Allow: Ctrl+V
      (event.key === 'x' && event.ctrlKey === true) || // Allow: Ctrl+X
      (event.key === 'a' && event.metaKey === true) || // Cmd+A (Mac)
      (event.key === 'c' && event.metaKey === true) || // Cmd+C (Mac)
      (event.key === 'v' && event.metaKey === true) || // Cmd+V (Mac)
      (event.key === 'x' && event.metaKey === true) // Cmd+X (Mac)
    ) {
      return; // let it happen, don't do anything
    }

    const start = event.target.selectionStart;
    const end = event.target.selectionEnd;
    // this.el.nativeElement.value = event.target.value.toUpperCase();
    event.target.value = event.target.value.toUpperCase();
    this.el.nativeElement.setSelectionRange(start, end);
    event.preventDefault();

    if (
      !this.lastValue ||
      (this.lastValue &&
        event.target.value.length > 0 &&
        this.lastValue !== event.target.value)
    ) {
      this.lastValue = this.el.nativeElement.value = event.target.value;
      // Propagation
      const evt = document.createEvent('HTMLEvents');
      evt.initEvent('input', false, true);
      event.target.dispatchEvent(evt);
    }
  }
}
